import { FC } from 'react';
import styled from 'styled-components';

import { Link } from '@/shared/navigation';
import { usePartnerData } from '@/shared/access';
import logoTC from './Sidebar/logo-TC.svg';

type HeaderLogoProps = {
  className?: string;
  isMobile?: boolean;
  onClick?: () => void;
};

const HeaderLogo: FC<HeaderLogoProps> = ({ className, isMobile, onClick }) => {
  const partner = usePartnerData();
  const partnerLogo = isMobile ? partner?.largeLogo : partner?.logo;

  return (
    <Root className={className} isPartner={!!partnerLogo} onClick={onClick}>
      {partnerLogo && (
        <LogoContainer to={'/'}>
          <img src={partnerLogo && partnerLogo !== 'default' ? partnerLogo : logoTC} alt="" />
        </LogoContainer>
      )}
    </Root>
  );
};

const Root = styled.div<{ isPartner: boolean }>`
  user-select: none;
  cursor: ${({ isPartner }) => (isPartner ? 'pointer' : 'none')};
  align-self: stretch;
  padding: 0 8px;
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: inherit;
  min-width: 0;
  img {
    max-width: 100%;
    width: 100%;
    min-height: 54px;
    object-fit: contain;
  }
`;

export default HeaderLogo;
